module.exports = __webpack_public_path__ + "static/media/1003.2408eec5.jpg";